module.exports = __webpack_public_path__ + "static/media/doc.37a56acc.svg";